import styled, { createGlobalStyle } from "styled-components"
import { globalStyleVariables } from "../../styles/variables"

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  }
  
  button, input, html {
    font-family: 'Inter', sans-serif;
    color: ${globalStyleVariables.BLUE_INACTIVE};
    -webkit-font-smoothing: antialiased;
    // overflow-x: hidden;
  }

  body {
    // overflow-x: hidden;
  }

  body, html, ul, li, p, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }
  
  header nav a {
    color: ${globalStyleVariables.TEXT_PRIMARY};
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
  }

  .dark-solid-bg {
    padding: 60px 0;
    background-color: #233142;
  }

  .hero-bg {
    position: absolute;
    background-image: url("https://imagekit.io/static/img/newPages/homepage-wave-bg.svg");
  }
`

export const MarkdownWrapper = styled.div`
  max-width: 700px;
  text-rendering: optimizeLegibility;
  line-height: 30px;
  text-size-adjust: 100%;
  margin: 0 auto;
  color: #313b3f;
  font-size: 18px;
  font-family: -apple-system,"system-ui","Segoe UI",Roboto,"Helvetica Neue",Ubuntu;

  @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
    padding: 0 20px;
    width: 100vw;
  }

  a {
    color: ${globalStyleVariables.LINK_COLOR};
  }

  ol, ul {
    padding-left: 40px;
    margin-bottom: 30px;

    &.contains-task-list {
      list-style: none;
      padding-left: 0px;
    }
  }

  li {
    margin-bottom: 5px;
  }

  blockquote {
    border-left: solid 10px ${globalStyleVariables.LOGO_BLUE};
    background: ${globalStyleVariables.MEDIUM_BG};
    padding: 25px;
    margin: 0px;
    margin-bottom: 20px;
  }

  .large-image-container {
    img {
      max-width: 100%;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 40px 0 20px 0;
    color: #090a0b;
    line-height: normal;
    position: relative;
    left: -25px;
    padding-left: 25px;

    .expand-control {
      cursor: pointer;
      vertical-align: middle;

      svg {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        display: inline;
      }
    }

    a {
      color: #090a0b;
      position: absolute;
      left: 0px;
      visibility: hidden;
      width: 30px;

      &:hover {
        visibility: visible;
      }

      svg {
        width: 20px;
        height: 25px;
        display: inline
      }
    }

    &:hover {
      a {
        visibility: visible;
      }
    }

    &:first-child {
      margin-top: 0;
    }
  }

  section {
    :not(:first-child) {
      h1,
      h2 {
        margin: 40px 0 20px 0 !important;
      }
    }
  }

  h3,
  h4,
  h5,
  h6 {
    margin: 20px 0 10px 0;
  }

  p {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 30px;

    &:last-child {
      margin: 0;
    }

    img {
      max-width: 100%;
    }
  }

  code {
    background: ${globalStyleVariables.INLINE_CODE_BG};
    border-radius: 3px;
    padding: 2px 5px;
    font-size: 16px;
  }

  pre {
    code {
      background: unset;
      border-radius: initial;
      padding: initial;
    }
  }

  figure {
    margin: 0;
    padding: 0;
    margin-bottom: 45px;
    margin-top: 45px;

    figcaption {
      text-align: center;
      font-size: 16px;
      line-height: 1.4;
      padding: 0 15px;
      color: ${globalStyleVariables.BLUE_PLACEHOLDER};
    }
  }

  .wide-table {
    @media (${globalStyleVariables.DESKTOP_MEDIA_QUERY}) {
      table {
        position: relative;
        width: 1000px !important;
        left: 50%;
        margin-left: -500px !important;
      }
    }
  }
`
